import { useQuery } from '@tanstack/react-query';

import { getLineItemData } from '../api/ventura/contract';
import { useConfig } from './useConfig';

function useContractLineItemData(contractId: number) {
  const { apiHost } = useConfig();

  const query = useQuery({
    queryKey: ['contractIoData', contractId],
    queryFn: () => getLineItemData(apiHost, contractId),
  });

  return query;
}

export default useContractLineItemData;
